import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const bulkEditPreviewFunc = createAsyncThunk(
  "bulkEditPreviewSlicer/bulkEditPreviewFunc",
  async (ids, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const idsParam = Array.isArray(ids) ? ids.join(",") : ids;
      const response = await api.get(
        `dashboard/products/bulk-edit-preview`,
        { params: { ids: idsParam } }
      );
      return response.data?.data?.products ?? [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const bulkEditPreviewSlicer = createSlice({
  name: "bulkEditPreviewSlicer",
  initialState: { data: [], loading: false, error: null },
  reducers: {
    clearBulkEditPreview: (state) => {
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(bulkEditPreviewFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkEditPreviewFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(bulkEditPreviewFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBulkEditPreview } = bulkEditPreviewSlicer.actions;
export default bulkEditPreviewSlicer.reducer;
